<template>
  <BreadCrumb PageTitle="Mes réclamations" />
  <ListClaims />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ListClaims from "../../components/Claims/ListClaims.vue";

export default defineComponent({
  name: "ListClaimsPage",
  components: {
    BreadCrumb,
    ListClaims,
  },
});
</script>